export default function ColoredElement({ params }) {
  const { align, background } = params;
  return (
    <div
      className={`ob-element ${align ? align : ""} ${
        background ? background : ""
      }`}
    ></div>
  );
}
